import React from "react";

import { SvgIcon } from "@mui/material/";

const ErrorOutlined = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 96 960 960">
      <path d="M479.614 762.462q12.848 0 21.925-8.691 9.076-8.691 9.076-21.539 0-12.847-8.691-21.924-8.69-9.077-21.538-9.077t-21.925 8.691q-9.076 8.691-9.076 21.538 0 12.848 8.691 21.925 8.69 9.077 21.538 9.077ZM452 628.154h58v-246h-58v246ZM480.409 952q-77.588 0-146.165-29.359-68.577-29.36-120.025-80.762-51.447-51.402-80.833-119.876Q104 653.529 104 575.675q0-78.11 29.418-146.412 29.419-68.303 80.922-119.917 51.503-51.614 119.875-80.48Q402.587 200 480.325 200q78.1 0 146.394 28.839 68.294 28.84 119.922 80.422 51.627 51.582 80.493 120.065Q856 497.809 856 575.674q0 77.865-28.839 146.102-28.84 68.237-80.408 119.786-51.569 51.548-120.034 80.993Q558.253 952 480.409 952ZM480 894q132.513 0 225.256-92.744Q798 708.513 798 576t-92.744-225.256Q612.513 258 480 258t-225.256 92.744Q162 443.487 162 576t92.744 225.256Q347.487 894 480 894Zm0-318Z" />
    </SvgIcon>
  );
};

export default ErrorOutlined;
